/* Simple jQuery Equal Heights @version 1.5.1. Copyright (c) 2013 Matt Banks. Dual licensed under the MIT and GPL licenses. */
!function(a){a.fn.equalHeights=function(){var b=0,c=a(this);return c.each(function(){var c=a(this).innerHeight();c>b&&(b=c)}),c.css("height",b)},a("[data-equal]").each(function(){var b=a(this),c=b.data("equal");b.find(c).equalHeights()})}(jQuery);

/* Run function after window resize */
var afterResize=(function(){var t={};return function(callback,ms,uniqueId){if(!uniqueId){uniqueId="Don't call this twice without a uniqueId";}if(t[uniqueId]){clearTimeout(t[uniqueId]);}t[uniqueId]=setTimeout(callback,ms);};})();

window.theme = window.theme || {};

theme.cacheSelectors = function () {
  theme.cache = {
    // General
    $w: $(window),
    $body: $('body'),

    // Mobile Nav
    $mobileNavTrigger: $('#MobileNavTrigger'),
    $mobileNav: $('#MobileNav'),
    $mobileSublistTrigger: $('.mobile-nav__sublist-trigger'),

    // Equal height elements
    $productGridImages: $('.grid-link__image--product'),
    $featuredGridImages: $('.grid-link__image--collection'),

    // Product page
    $productImage: $('#ProductPhotoImg'),
    $productImageGallery: $('.gallery__item'),

    // Cart Page
    cartNoteAdd: '.cart__note-add',
    cartNote: '.cart__note',

    // Add to cart - Ajax
    $cartCount: $('.cart-count'),
    $addToCartBtn: $('form[action^="/cart/add"] :submit'),

    //Navigation
    $hasDropdownItem: $('.site-nav--has-dropdown')
  }
};

timber.cacheVariables = function () {
  timber.vars = {
    isTouch: timber.cache.$html.hasClass('supports-touch')
  }
};

theme.init = function () {
  theme.cacheSelectors();
  theme.mobileNav();
  timber.cacheVariables();
  theme.equalHeights();
  theme.cartPage();
  theme.toggleMenu();
   theme.homeInstagramFeed();

  

  
    theme.enableAjax();
  
};

theme.mobileNav = function () {
  theme.cache.$mobileNavTrigger.on('click', function() {
    theme.cache.$mobileNav.slideToggle(220);
  });

  theme.cache.$mobileSublistTrigger.on('click', function(evt) {
    var $el = $(this);

    // Enable commented out if statement to allow direct clicking on trigger link
    // if (!$el.hasClass('is-active')) {
      evt.preventDefault();
      $el.toggleClass('is-active').next('.mobile-nav__sublist').slideToggle(200);
    // }
  });
};

theme.equalHeights = function () {
  theme.cache.$w.on('load', resizeElements());

  theme.cache.$w.on('resize',
    afterResize(function() {
      resizeElements();
    }, 250, 'equal-heights')
  );

  function resizeElements() {
    theme.cache.$productGridImages.css('height', 'auto').equalHeights();
    theme.cache.$featuredGridImages.css('height', 'auto').equalHeights();
  }
};

theme.productImageGallery = function() {

  if (!theme.cache.$productImageGallery.length) {
    return;
  };

  theme.cache.$productImageGallery.magnificPopup({
    type: 'image',
    mainClass: 'mfp-fade',
    closeOnBgClick: true,
    closeBtnInside: false,
    closeOnContentClick: true,
    tClose: 'Close (Esc)',
    removalDelay: 500,
    callbacks: {
      open: function(){
        $('html').css('overflow-y','hidden');
      },
      close: function(){
        $('html').css('overflow-y','');
      }
    },
    gallery: {
      enabled: true,
      navigateByImgClick: false,
      arrowMarkup: '<button title="%title%" type="button" class="mfp-arrow mfp-arrow-%dir%"><span class="mfp-chevron mfp-chevron-%dir%"></span></button>',
      tPrev: 'Previous (Left arrow key)',
      tNext: 'Next (Right arrow key)'
    }
  });

  theme.cache.$productImage.bind('click', function() {
    var imageId = $(this).attr('data-image-id');
    theme.cache.$productImageGallery.filter('[data-image-id="' + imageId + '"]').trigger('click');
  });
};

theme.cartPage = function () {
  

  theme.cache.$body.on('click', theme.cache.cartNoteAdd, function () {
    $(this).addClass('is-hidden');
    $(theme.cache.cartNote).addClass('is-active');
    ajaxifyShopify.sizeDrawer();
  });
};

theme.backButton = function () {
  var referrerDomain = urlDomain(document.referrer);
  var shopDomain = urlDomain(document.url);

  if (shopDomain === referrerDomain) {
    history.back();
    return false;
  }

  function urlDomain(url) {
    var    a      = document.createElement('a');
           a.href = url;
    return a.hostname;
  }
};


/*
 * Function to remove items from cart
 */
$('.cart-actions').on('click', '.remove_item', function(e) {
  e.preventDefault();

  $.ajax({
    url: '/cart/change.js',
    dataType: 'json',
    type: 'post',
    data: {
      quantity: 0,
      id: $(this).data('id')
    },
    success: function(cart) {
      theme.cache.renderCart(cart);
    }
  });
});

$('.cart-actionstwo').on('click', '.remove_item', function(e) {
  e.preventDefault();

  $.ajax({
    url: '/cart/change.js',
    dataType: 'json',
    type: 'post',
    data: {
      quantity: 0,
      variant_id: $(this).data('id')
    },
    success: function(cart) {
      theme.cache.renderCart(cart);
    }
  });
});
theme.addToCartflip = function ($addToCartBtn) {

console.log("tjek");
  // Get label of add to cart button
  var addToCartText = $addToCartBtn.attr('data-add-to-cart') || "Add to Cart";
  if($('#page.stl__collection').length === 1){

      $('.view-cart .view-cart-btn').bind('click', function(e) {
          $('#cart').css('display', 'block');
      });
    console.log("true");
    $addToCartBtn
      .prop('disabled', false)
      .removeClass('disabled')

    $addToCartBtn
      .prop('disabled', false)
      .addClass('btn--flipped')



  } else {
    // Make a copy of the add to cart button should we flip it
    $addToCartBtn
      .clone(true)
      .prop('disabled', false)
      .removeClass('disabled')
      .addClass('btn--unflipped')
      .find('span')
      .text(addToCartText)
      .end()
      .hide()
      .insertAfter($addToCartBtn);

    $addToCartBtn
      .unbind('click')
      .removeClass('disabled')
      .find('span')
      .text("View cart")
      .end()
      .bind('click', function(e) {
        e.preventDefault();
        window.location.href = '/cart';
      })
      .prop('disabled', false)
      .addClass('btn--flipped')
      .after('<span class="continue-shopping"> <a class="btn--secondary" href="/collections/all">Continue shopping</a></span>');

  }

  $('.continue-shopping a').bind('click', theme.backButton);

  // Unflip button if another variant is selected
  $('.single-option-selector, [name="quantity"]').bind('click', function() {
    $(this).closest('form').find('.btn--flipped, .continue-shopping, .note').remove();
    $(this).closest('form').find('.btn--unflipped').removeClass('.btn--unflipped').show();
  });
};




theme.enableAjax = function () {
  /*
   * Function to render hover cart
   */
  theme.cache.renderCart = function(cart) {
    $headerCart = $('.cart-hover .cart-actions');

    theme.cache.$cartCount.text(cart.item_count);
    $('.hidden-count').removeClass('hidden-count');

    $headerCart.empty();

    if (cart.item_count === 0) {
      $headerCart.removeClass('cart-show');
    }
    else {

      $.each(cart.items, function(index, item) {
      
        var multiplier = 1;
      

        $headerCart.append('<div class="quick-cart-item clearfix">'
                           + '<div class="quick-cart-image">'
                           + '<a href="' + item.url + '" title="' + item.title + '">'
                           + '<img src="' + Shopify.resizeImage(item.image, 'small') + '">'
                           + '</a>'
                           + '</div>'
                           + '<div class="quick-cart-details">'
                           + '<p><a href="' + item.url + '">' + item.title + '</a></p>'
                           + '<p>' + Shopify.formatMoney(item.price * multiplier) + '</p>      '
                           + '<a class="remove_item" href="#" data-id="' + item.variant_id + '">Remove</a>'
                           + '</div>'
                           + '</div>');

        $headerCart.addClass("cart-show");
      });

        $headerCart.append('<a class="cart-link-btn btn-grey" href="/cart">Cart'
                           + '</a>'
         				   + '<a class="checkout-link-btn" href="/checkout">'
                           + 'Check Out'
                           + '</a>');
    }
  };

  theme.cache.$addToCartBtn.bind('click', function(e) {
    $messageCart = $('<p class="add-to-cart-msg"></p>');
    e.preventDefault();

    $('.note.errors').remove();

    var $addToCartBtn = $(this),
        $addToCartForm = $(this).closest('form'),
        $addToCartBtnText = $(this).find('span');

    if ($addToCartForm.length) {
      $addToCartBtn
        .attr('data-add-to-cart', $addToCartBtnText.text())
        .prop('disabled', true)
        .addClass('disabled')
        .addClass('btn--loading');

      $.ajax({
        url: '/cart/add.js',
        dataType: 'json',
        type: 'post',
        data: $addToCartForm.serialize(),
        success: function(lineItem) {

          $.getJSON('/cart.js', function(cart) {
            theme.cache.renderCart(cart);
          });

          $addToCartBtn.removeClass('btn--loading');
          theme.addToCartflip($addToCartBtn);
          if($('#page.stl__collection').length === 1){
            $messageCart.text("Product Added");
            $addToCartBtn.after($messageCart);
            $messageCart.delay(500).fadeIn(800);
            $messageCart.delay(2000).fadeOut(800);
            $addToCartBtn.after('<span class="view-cart"> <a class="btn--secondary view-cart-btn" href="#">View cart</a></span>');
          }
          if( /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) ) {
            $('.view-cart .view-cart-btn').bind('click', function(e) {
              e.preventDefault();
              window.location.href = '/cart';
            });
          } else {
            $('.view-cart .view-cart-btn').bind('click', function(e) {
              $("html, body").animate({scrollTop: $(".header-bar").offset().top}, 500);
                $('.cart-actions').addClass('cart-show');
            });
          };
        },
        error: function(XMLHttpRequest, textStatus) {
          var data = eval('(' + XMLHttpRequest.responseText + ')');
          var response = data.description;
          var status = XMLHttpRequest.status;
          $addToCartBtn.removeClass('btn--loading');
          if (status === 422 && $('#productSelect option').length === 1) {
            $addToCartBtnText.text("Coming soon");
          }
          else {
            $addToCartBtn.prop('disabled', false).removeClass('disabled');
            $addToCartBtnText.text($addToCartBtn.attr('data-add-to-cart'));
          }

          $addToCartBtn.after('<p class="note errors">' + response + '</p>');
        }
      });
    }
  });
};

theme.homeInstagramFeed = function () {
    var instaFeed = $('.js-home-insta');

    instaFeed.each(function(i) {
        var thisToken = $(instaFeed[i]).attr('data-insta-token');
        var thisUserId = thisToken.split('.')[0];
        var thisFeedCount = $(instaFeed[i]).attr('data-insta-count');

        function successFunc(data) {
            constructFeed(data, this.indexValue);
			
            function constructFeed(data, feedCount) {
              	console.log(data);
                var thisFeed = $('.js-home-insta')[feedCount];
                var thisList = $(thisFeed).find('.js-home-insta-list');
                var feed = data.data;
                var userName = data.data[0].user.username;
              
              

                //set URL to user account
                $(thisFeed).parent('.js-home-insta-link').attr('href', 'https://www.instagram.com/'+ userName);

                //empty list element so when editing inside sections images don't get doubled
                $(thisList).empty();

                //ceate images in list element
                for (var i = 0; i < thisFeedCount; i++) {
                    var image = feed[i].images.standard_resolution.url;
                    $(thisList).append('<div class="home-insta__item"><div class="o-ratio"><div class="o-ratio__content"><div style="background-image:url('+ image +')" class="home-insta__img"></div></div></div>');
                }
            }
        }
        //check token is entered
        if (thisToken !== '') {
            //get feed via ajax
            $.ajax({
                url: 'https://api.instagram.com/v1/users/'+ thisUserId +'/media/recent/?count='+ thisFeedCount +'&access_token=' + thisToken,
                dataType: 'jsonp',
                crossDomain: true,
                indexValue: i,
                success: successFunc
            });
        }

    });
};

theme.toggleMenu = function () {
  var $doc = $(document);
  var showDropdownClass = 'show-dropdown';

  // Open sub navs on small screens
  theme.cache.$hasDropdownItem.on('click', function(evt) {
    var $el = $(this);

    if (!$el.hasClass(showDropdownClass) && timber.vars.isTouch) {
      evt.preventDefault();
      $el.addClass(showDropdownClass);
      $doc.on('click', handleClickOutsideDropdown);
    }

    function handleClickOutsideDropdown (evt) {
      var $target = $(evt.target);

      if (!$target.is($el) && !$.contains($el[0], $target[0])) {
        $el.removeClass(showDropdownClass);
        $doc.off('click', handleClickOutsideDropdown)
      }
    }
  })
};
if (window.Shopify && Shopify.StorefrontExpressButtons) {
  Shopify.StorefrontExpressButtons.initialize();
}


// Initialize theme's JS on docready
$(theme.init)

/*============== Album Gallery ==============*/

$(document).ready(function(){


		var initPhotoSwipeFromDOM = function(gallerySelector) {

			var parseThumbnailElements = function(el) {
			    var thumbElements = el.childNodes,
			        numNodes = thumbElements.length,
			        items = [],
			        el,
			        childElements,
			        thumbnailEl,
			        size,
			        item;

			    for(var i = 0; i < numNodes; i++) {
			        el = thumbElements[i];

			        // include only element nodes
			        if(el.nodeType !== 1) {
			          continue;
			        }

			        childElements = el.children;

			        size = el.getAttribute('data-size').split('x');

			        // create slide object
			        item = {
						src: el.getAttribute('href'),
						w: parseInt(size[0], 10),
						h: parseInt(size[1], 10),
						author: el.getAttribute('data-author')
			        };

			        item.el = el; // save link to element for getThumbBoundsFn

			        if(childElements.length > 0) {
			          item.msrc = childElements[0].getAttribute('src'); // thumbnail url
			          if(childElements.length > 1) {
			              item.title = childElements[1].innerHTML; // caption (contents of figure)
			          }
			        }


					var mediumSrc = el.getAttribute('data-med');
		          	if(mediumSrc) {
		            	size = el.getAttribute('data-med-size').split('x');
		            	// "medium-sized" image
		            	item.m = {
		              		src: mediumSrc,
		              		w: parseInt(size[0], 10),
		              		h: parseInt(size[1], 10)
		            	};
		          	}
		          	// original image
		          	item.o = {
		          		src: item.src,
		          		w: item.w,
		          		h: item.h
		          	};

			        items.push(item);
			    }

			    return items;
			};

			// find nearest parent element
			var closest = function closest(el, fn) {
			    return el && ( fn(el) ? el : closest(el.parentNode, fn) );
			};

			var onThumbnailsClick = function(e) {
			    e = e || window.event;
			    e.preventDefault ? e.preventDefault() : e.returnValue = false;

			    var eTarget = e.target || e.srcElement;

			    var clickedListItem = closest(eTarget, function(el) {
			        return el.tagName === 'A';
			    });

			    if(!clickedListItem) {
			        return;
			    }

			    var clickedGallery = clickedListItem.parentNode;

			    var childNodes = clickedListItem.parentNode.childNodes,
			        numChildNodes = childNodes.length,
			        nodeIndex = 0,
			        index;

			    for (var i = 0; i < numChildNodes; i++) {
			        if(childNodes[i].nodeType !== 1) {
			            continue;
			        }

			        if(childNodes[i] === clickedListItem) {
			            index = nodeIndex;
			            break;
			        }
			        nodeIndex++;
			    }

			    if(index >= 0) {
			        openPhotoSwipe( index, clickedGallery );
			    }
			    return false;
			};

			var photoswipeParseHash = function() {
				var hash = window.location.hash.substring(1),
			    params = {};

			    if(hash.length < 5) { // pid=1
			        return params;
			    }

			    var vars = hash.split('&');
			    for (var i = 0; i < vars.length; i++) {
			        if(!vars[i]) {
			            continue;
			        }
			        var pair = vars[i].split('=');
			        if(pair.length < 2) {
			            continue;
			        }
			        params[pair[0]] = pair[1];
			    }

			    if(params.gid) {
			    	params.gid = parseInt(params.gid, 10);
			    }

			    return params;
			};

			var openPhotoSwipe = function(index, galleryElement, disableAnimation, fromURL) {
			    var pswpElement = document.querySelectorAll('.pswp')[0],
			        gallery,
			        options,
			        items;

				items = parseThumbnailElements(galleryElement);

			    // define options (if needed)
			    options = {

			        galleryUID: galleryElement.getAttribute('data-pswp-uid'),

			        getThumbBoundsFn: function(index) {
			            // See Options->getThumbBoundsFn section of docs for more info
			            var thumbnail = items[index].el.children[0],
			                pageYScroll = window.pageYOffset || document.documentElement.scrollTop,
			                rect = thumbnail.getBoundingClientRect();

			            return {x:rect.left, y:rect.top + pageYScroll, w:rect.width};
			        },

			        addCaptionHTMLFn: function(item, captionEl, isFake) {
						if(!item.title) {
							captionEl.children[0].innerText = '';
							return false;
						}
                      captionEl.children[0].innerHTML = '<a href="/pages/image-bank">Back to Album</a>  <span> Caption:' + item.title + '</span> ';
						return true;
			        }

			    };


			    if(fromURL) {
			    	if(options.galleryPIDs) {
			    		// parse real index when custom PIDs are used
			    		// http://photoswipe.com/documentation/faq.html#custom-pid-in-url
			    		for(var j = 0; j < items.length; j++) {
			    			if(items[j].pid == index) {
			    				options.index = j;
			    				break;
			    			}
			    		}
				    } else {
				    	options.index = parseInt(index, 10) - 1;
				    }
			    } else {
			    	options.index = parseInt(index, 10);
			    }

			    // exit if index not found
			    if( isNaN(options.index) ) {
			    	return;
			    }



				var radios = document.getElementsByName('gallery-style');
				for (var i = 0, length = radios.length; i < length; i++) {
				    if (radios[i].checked) {
				        if(radios[i].id == 'radio-all-controls') {

				        } else if(radios[i].id == 'radio-minimal-black') {
				        	options.mainClass = 'pswp--minimal--dark';
					        options.barsSize = {top:0,bottom:0};
							options.captionEl = false;
							options.fullscreenEl = false;
							options.shareEl = false;
							options.bgOpacity = 0.85;
							options.tapToClose = true;
							options.tapToToggleControls = false;
				        }
				        break;
				    }
				}

			    if(disableAnimation) {
			        options.showAnimationDuration = 0;
			    }

			    // Pass data to PhotoSwipe and initialize it
			    gallery = new PhotoSwipe( pswpElement, PhotoSwipeUI_Default, items, options);

			    // see: http://photoswipe.com/documentation/responsive-images.html
				var realViewportWidth,
				    useLargeImages = false,
				    firstResize = true,
				    imageSrcWillChange;

				gallery.listen('beforeResize', function() {

					var dpiRatio = window.devicePixelRatio ? window.devicePixelRatio : 1;
					dpiRatio = Math.min(dpiRatio, 2.5);
				    realViewportWidth = gallery.viewportSize.x * dpiRatio;


				    if(realViewportWidth >= 1200 || (!gallery.likelyTouchDevice && realViewportWidth > 800) || screen.width > 1200 ) {
				    	if(!useLargeImages) {
				    		useLargeImages = true;
				        	imageSrcWillChange = true;
				    	}

				    } else {
				    	if(useLargeImages) {
				    		useLargeImages = false;
				        	imageSrcWillChange = true;
				    	}
				    }

				    if(imageSrcWillChange && !firstResize) {
				        gallery.invalidateCurrItems();
				    }

				    if(firstResize) {
				        firstResize = false;
				    }

				    imageSrcWillChange = false;

				});

				gallery.listen('gettingData', function(index, item) {
				    if( useLargeImages ) {
				        item.src = item.o.src;
				        item.w = item.o.w;
				        item.h = item.o.h;
				    } else {
				        item.src = item.m.src;
				        item.w = item.m.w;
				        item.h = item.m.h;
				    }
				});

			    gallery.init();
			};

			// select all gallery elements
			var galleryElements = document.querySelectorAll( gallerySelector );
			for(var i = 0, l = galleryElements.length; i < l; i++) {
				galleryElements[i].setAttribute('data-pswp-uid', i+1);
				galleryElements[i].onclick = onThumbnailsClick;
			}

			// Parse URL and open gallery if it contains #&pid=3&gid=1
			var hashData = photoswipeParseHash();
			if(hashData.pid && hashData.gid) {
				openPhotoSwipe( hashData.pid,  galleryElements[ hashData.gid - 1 ], true, true );
			}
		};

		initPhotoSwipeFromDOM('.demo-gallery');
     $(".demo-gallery").slick({
    dots: false,
    // shows/hides left/right arrow
    arrows: true,
    fade:true,
    adaptiveHeight: true,
    // if set will show custom carousel paging e.g. by default it shows number instead of dots
    // customPaging : function(slider, i) {
    // return '<a>'+(i+1)+'</a>';
    // },
    // Number of rows to show in the carousel
    rows: 1,
    // defines the speed of carousel slide
    speed: 300,
    swipe:false,
    swipeToSlide:false,
    touchMove:false,
    // if set the carousel will always be slid to first slide if no slide left
    infinite: false,
    // active slide will be centered if true
    centerMode: false,
    // How many slides per row
    slidesToShow: 1,
    // How many slides to scroll on slide left or right mostly equals to slidesToShow
    slidesToScroll: 1,
    asNavFor: '.download-image',
    prevArrow: '<div class="slick-prev"><i class="i-chev-left-thin"></i><span class="sr-text">Previous</span></div>',
    nextArrow: '<div class="slick-next"><i class="i-chev-right-thin"></i><span class="sr-text">Next</span></div>'

  });

  $('.download-image').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    swipe:false,
    swipeToSlide:false,
    touchMove:false,
    asNavFor: '.demo-gallery',
    adaptiveHeight: true,
    dots: false,
    arrows:false,
    fade:true,
  });
$(document)
  .on('shopify:section:deselect', function(e){
  $(".demo-gallery").slick({
    dots: false,
    // shows/hides left/right arrow
    arrows: true,
    fade:true,
    adaptiveHeight: true,
    // if set will show custom carousel paging e.g. by default it shows number instead of dots
    // customPaging : function(slider, i) {
    // return '<a>'+(i+1)+'</a>';
    // },
    // Number of rows to show in the carousel
    rows: 1,
    // defines the speed of carousel slide
    speed: 300,
    swipe:false,
    swipeToSlide:false,
    touchMove:false,
    // if set the carousel will always be slid to first slide if no slide left
    infinite: false,
    // active slide will be centered if true
    centerMode: false,
    // How many slides per row
    slidesToShow: 1,
    // How many slides to scroll on slide left or right mostly equals to slidesToShow
    slidesToScroll: 1,
    asNavFor: '.download-image',
    prevArrow: '<div class="slick-prev"><i class="i-chev-left-thin"></i><span class="sr-text">Previous</span></div>',
    nextArrow: '<div class="slick-next"><i class="i-chev-right-thin"></i><span class="sr-text">Next</span></div>'

  });

  $('.download-image').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    swipe:false,
    swipeToSlide:false,
    touchMove:false,
    asNavFor: '.demo-gallery',
    adaptiveHeight: true,
    dots: false,
    arrows:false,
    fade:true,
  });
});
  $(document)
  .on('shopify:section:select', function(e){
      $(".demo-gallery").slick({
    dots: false,
    // shows/hides left/right arrow
    arrows: true,
    fade:true,
    adaptiveHeight: true,
    // if set will show custom carousel paging e.g. by default it shows number instead of dots
    // customPaging : function(slider, i) {
    // return '<a>'+(i+1)+'</a>';
    // },
    // Number of rows to show in the carousel
    rows: 1,
    // defines the speed of carousel slide
    speed: 300,
    swipe:false,
    swipeToSlide:false,
    touchMove:false,
    // if set the carousel will always be slid to first slide if no slide left
    infinite: false,
    // active slide will be centered if true
    centerMode: false,
    // How many slides per row
    slidesToShow: 1,
    // How many slides to scroll on slide left or right mostly equals to slidesToShow
    slidesToScroll: 1,
    asNavFor: '.download-image',
    prevArrow: '<div class="slick-prev"><i class="i-chev-left-thin"></i><span class="sr-text">Previous</span></div>',
    nextArrow: '<div class="slick-next"><i class="i-chev-right-thin"></i><span class="sr-text">Next</span></div>'

  });

  $('.download-image').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    swipe:false,
    swipeToSlide:false,
    touchMove:false,
    asNavFor: '.demo-gallery',
    adaptiveHeight: true,
    dots: false,
    arrows:false,
    fade:true,
  });
  });


$('#gallery').find('.pswp__button--arrow--left').on( "click touchstart", function()  {
     $( ".demo-gallery" ).find('.slick-prev').trigger( "click" );
});
    $('#gallery').find('.pswp__button--arrow--right').on( "click touchstart", function()  {
 $( ".demo-gallery" ).find('.slick-next').trigger( "click" );
});
});



window.addEventListener('load', () => {
  var inputs = document.querySelectorAll('input[name=return_to]');

  inputs.forEach(input => {
    input.value = window.location.href.split('camcamcopenhagen.com')[1];
  });
});